import React, { useState } from "react";
import "./Checkbox.scss";

// TODO Abstract the inline style within this class further.

export const Checkbox = ({
  checked = false,
  opaqueCheckbox = true, // this option only alters the opacity of the label text
  color = "white",
  label = "",
  name = "",
  renderAs = "line", // square / circle / line
  tooltip = null,
  ...props
}) => {
  const [showTooltip, setShowTooltip] = useState(false);

  let borderRadius = `25%`;
  let checkboxWidth = `12.5px`;
  let checkboxHeight = `12.5px`;
  // used to vary the width of the checkbox when it is checked
  let checkboxWidthChecked = `12.5px`;
  let checkboxHeightChecked = `12.5px`;

  let checkmarkClassName = "checkmark ";

  if (renderAs === "circle") {
    borderRadius = `50%`;
    checkboxWidth = `7px`;
    checkboxHeight = `7px`;
    checkmarkClassName += "checkmark__circle";
  } else if (renderAs === "line") {
    borderRadius = `0`;
    checkboxWidth = `2px`;
    checkboxWidthChecked = `9px`;
    checkmarkClassName += "checkmark__line";
  } else {
    checkmarkClassName += "checkmark__square";
  }

  return (
    <label
      style={{
        "--data-color": color,
        "--data-border-radius": borderRadius,
        "--checkbox-width": checkboxWidth,
        "--checkbox-height": checkboxHeight,
        "--checkbox-width-checked": checkboxWidthChecked,
        "--checkbox-height-checked": checkboxHeightChecked,
      }}
      className={`relative checkbox ${opaqueCheckbox && "opaque"}`}
      onMouseOver={() => setShowTooltip(true)}
      onMouseOut={() => setShowTooltip(false)}
    >
      {showTooltip && tooltip && (
        <div
          style={{ width: `fit-content`, maxWidth: `200px`, left: `80px` }}
          className="mt3 z3 p1 mxn4 border rounded absolute right-0 bg-primary"
        >
          {tooltip}
        </div>
      )}
      <input type="checkbox" checked={checked} name={name} {...props} />
      <span className="checkbox__label">{label}</span>
      <span className={checkmarkClassName} />
    </label>
  );
};
